"use client";
import React, { useEffect } from 'react';
import { ReactNode } from 'react';


export const DisableRightClick = ({ children, isEnable }: { children: ReactNode; isEnable: string }) => {
    const config = { disableContextMenu: isEnable };

    useEffect(() => {
        if (config.disableContextMenu === 'NONE') return;
    
        const handleContextMenu = (e: MouseEvent) => e.preventDefault();
    
        if (config.disableContextMenu === 'ALL') {
            window.addEventListener('contextmenu', handleContextMenu);
            return () => window.removeEventListener('contextmenu', handleContextMenu);
        }
    
        // Helper functions to manage event listeners on images
        const toggleContextMenuListener = (img: HTMLImageElement, add: boolean) => {
            const method = add ? 'addEventListener' : 'removeEventListener';
            img[method]('contextmenu', handleContextMenu as EventListener);
        };
    
        const processNodes = (nodes: NodeList, add: boolean) => {
            nodes.forEach((node) => {
                if (node.nodeName === 'IMAGE') {
                    toggleContextMenuListener(node as HTMLImageElement, add);
                } else if (node.nodeType === 1) {
                    const imgs = (node as HTMLElement).querySelectorAll('img');
                    imgs.forEach((img) => toggleContextMenuListener(img, add));
                }
            });
        };
    
        // Observe DOM mutations for dynamically added/removed images
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'childList') {
                    processNodes(mutation.addedNodes, true);
                    processNodes(mutation.removedNodes, false);
                }
            });
        });
    
        observer.observe(document.body, { childList: true, subtree: true });
    
        // Add context menu listener to existing images
        const existingImages = document.querySelectorAll('img');
        existingImages.forEach((img) => toggleContextMenuListener(img, true));
    
        return () => {
            // Cleanup: disconnect observer and remove listeners
            observer.disconnect();
            existingImages.forEach((img) => toggleContextMenuListener(img, false));
        };
    }, [config]);

    return <>{children}</>;
}
